import { InspectorTabs } from "@/components/inspector/tab/InspectorTabs";
import { LayerDto, MaterialDto } from "@/types/data-types";
import HENGE from "@henge-inc/global-types";
import HUI from "@henge-inc/ui/v1_2";
import React from "react";

interface InspectorPanelProps {
  layerInfo: LayerDto;
  currentMaterial: MaterialDto;
  setCurrentMaterial: React.Dispatch<React.SetStateAction<MaterialDto>>;
}

export const InspectorPanel = ({
  layerInfo,
  currentMaterial,
  setCurrentMaterial,
}: InspectorPanelProps) => {
  return (
    <div className="flex flex-col w-[256px] p-2 bg-[var(--white)] rounded-lg shadow-[0_0_4px_0_rgba(0,0,0,0.05)]">
      <div className="flex flex-col gap-0">
        <div className="flex flex-col p-1">
          <HUI.Text
            kind={HENGE.TEXT_KIND.small}
            weight={HENGE.TEXT_WEIGHT.medium}
            lineHeight={HENGE.TEXT_LINE_HEIGHT.medium}
            className="select-none"
          >
            Layer
          </HUI.Text>
          <HUI.Text
            kind={HENGE.TEXT_KIND.body2}
            weight={HENGE.TEXT_WEIGHT.medium}
            lineHeight={HENGE.TEXT_LINE_HEIGHT.medium}
            className="select-none"
          >
            {layerInfo.name}
          </HUI.Text>
        </div>
        <InspectorTabs
          layerInfo={layerInfo}
          currentMaterial={currentMaterial}
          setCurrentMaterial={setCurrentMaterial}
        />
      </div>
    </div>
  );
};
